import * as React from "react";

function Remove(props: React.SVGProps<SVGSVGElement>) {
  return <svg width={18} height={18} viewBox="0 0 18 18" fill="currentColor" {...props}><path fillRule="evenodd" d="M13.5,8 C13.7761424,8 14,8.22385763 14,8.5 L14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L4.5,10 C4.22385763,10 4,9.77614237 4,9.5 L4,8.5 C4,8.22385763 4.22385763,8 4.5,8 L13.5,8 Z" fill="" /></svg>;
}

export default Remove;